import React from 'react';
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function MinusRegularIcon(props) {
  return <FontAwesomeIcon icon={faMinus} {...props} />;
}
